@let isUpdating = functionalUsagePlugin.selectors.isUpdating.asSignal();

@if (isUpdating) {
  @let isManualMethodology = isManualMethodologySg();
  @let isServiceCenterMethodology = isServiceCenterMethodologySg();
  @let isJointUseMethodology = isJointUseMethodologySg();
  @let isAutoLabBasedMethodology = isAutoLabBasedMethodologySg();
  @let methodology = methodologySg();
  @let isLoading = functionalUsagePlugin.selectors.isLoading.asSignal();
  @let canConfirm = canConfirmSg();

  <atn-ds-centered-overlay type="wide">
    <div class="atn-space-functional-usage-modal">
      <atn-ds-widget title="Update Functional Usage">
        <div actions>
          <i
            class="atn-icon atn-close atn-red"
            (click)="cancelClickHandler()"
          ></i>
        </div>

        <div class="atn-space-functional-usage-modal__content">
          <div class="atn-space-functional-usage-modal__field">
            <span><b>Methodology</b></span>
            <atn-ds-select-single
              [items]="methodologyItemsSg()"
              [value]="methodology"
              [required]="true"
              (valueChange)="updateFunctionalizationMethodology($event)"
            />
          </div>

          @if (isManualMethodology) {
            <div class="atn-space-functional-usage-modal__field">
              <span><b>Allocations</b></span>
              <atn-space-modal-functionalizations
                [functionalizations]="manualFunctionalizationsSg()"
                (functionalizationChange)="updateFunctionalization($event)"
              />
            </div>

            @let sponsoredFuncUsageWarning =
              recordWarningsPlugin.selectors
                .getMessage(
                  WarningCode.MissingFunctionalUsagesForSelectedAccounts
                )
                .asSignal();
            @if (sponsoredFuncUsageWarning) {
              <atn-ds-notice
                [style]="DisplayStyle.Warning"
                [description]="sponsoredFuncUsageWarning"
              />
            }
          }

          @if (isServiceCenterMethodology) {
            @let serviceCenterId = serviceCenterIdSg();
            @let serviceCenterItems = serviceCenterItemsSg();

            <div class="atn-space-functional-usage-modal__field">
              <span><b>Service Center</b></span>
              <atn-ds-select-single
                [items]="serviceCenterItems"
                [value]="serviceCenterId"
                [required]="true"
                (valueChange)="updateServiceCenterHandler($event)"
              />
            </div>

            <div class="atn-space-functional-usage-modal__field">
              <span><b>Allocations</b></span>
              <atn-space-modal-functionalizations
                [functionalizations]="serviceCenterFunctionalizationsSg()"
                [readonly]="true"
              />
            </div>
          }
          @if (isAutoLabBasedMethodology) {
            @let autoLabBasedFunctionalizations =
              this.labServiceFunctionalUsagePlugin.selectors.functionalizations.asSignal();
            @let isLoadingAutoLabBased =
              this.labServiceFunctionalUsagePlugin.selectors.isLoading.asSignal();

            <div
              class="atn-space-functional-usage-modal__field atn-space-functional-usage-modal__field--full-height"
            >
              <span><b>Allocations</b></span>
              <atn-space-modal-functionalizations
                [functionalizations]="autoLabBasedFunctionalizations"
                [loading]="isLoadingAutoLabBased"
                [readonly]="true"
              />
            </div>
          }

          @if (isJointUseMethodology) {
            @let occupierExists = occupierOrganizationSg();
            @let jointUseFunctionalizations =
              jointUsePluginSg()?.feature?.selectors?.functionalizations?.asSignal() ??
              [];
            @let isLoadingJointUse =
              jointUsePluginSg()?.feature?.selectors?.isLoading?.asSignal() ??
              false;
            <div
              class="atn-space-functional-usage-modal__field atn-space-functional-usage-modal__field--full-height"
            >
              <span><b>Allocations</b></span>
              @if (occupierExists) {
                <atn-space-modal-functionalizations
                  [functionalizations]="jointUseFunctionalizations"
                  [loading]="isLoadingJointUse"
                  [readonly]="true"
                />
              } @else {
                <atn-ds-notice
                  description="Space Record must have assigned Occupier Organization to use Joint Use methodology."
                  [style]="DisplayStyle.Warning"
                />
              }
            </div>
          }
        </div>

        <div
          class="atn-space-functional-usage-modal__footer"
          footer
        >
          <atn-ds-button
            type="transparent"
            (click)="cancelClickHandler()"
            >Cancel</atn-ds-button
          >
          <atn-ds-button
            (click)="saveClickHandler()"
            [disabled]="!canConfirm"
            [loading]="isLoading"
            >Save</atn-ds-button
          >
        </div>
      </atn-ds-widget>
    </div>
  </atn-ds-centered-overlay>
}
